import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useAuth0 } from "@auth0/auth0-react";
import { useGetSchoolsQuery } from "state/api";

const AdminPage = () => {
  const { loginWithRedirect } = useAuth0();
  const { data: schoolsData, isLoading: isSchoolsDataLoading } =
    useGetSchoolsQuery();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      {/* Display schoolsData in a dropdown */}
      <Button
        variant="contained"
        onClick={() =>
          loginWithRedirect({
            authorizationParams: {
              prompt: "consent",
            },
          })
        }
      >
        Admin Login
      </Button>
    </Box>
  );
};

export default AdminPage;
